import Vue from 'vue';
import VueI18n from 'vue-i18n';
import _ from 'lodash';
import zh from './lang/zh';
import en from './lang/en';
import ko from './lang/ko';
import id from './lang/id';

import { changeURLArg, getCookie } from "../utils";

Vue.use(VueI18n);

let availableLocale = ['zh', 'en', 'ko', 'id'];

let defaultLangStr = navigator.language;
let defaultLang = 'en';

if (defaultLangStr.indexOf('zh') >= 0) {
  defaultLang = 'zh';
}

let query = location.search.substr(1);
let queryObj = {};

if (query) {
  _.forEach(query.split('&'), item => {
    let tempArr = item.split('=');
    queryObj[tempArr[0]] = tempArr[1];
  });
}

let locale = _.includes(availableLocale, queryObj['locale']) ? queryObj['locale'] : defaultLang;

if (queryObj['locale']) {
  locale = queryObj['locale']
  changeURLArg({ locale: '' })
} else {
  locale = localStorage.getItem('lang') || locale;
}

locale = getCookie('lang') || locale;

let i18n = new VueI18n({
  locale,
  messages: {
    'en': en,
    'zh': zh,
    'ko': ko,
    'id': id
  }
});

export default i18n;